export const BANK = 'BANK';